import Icon from '../components/Icon.vue';
Icon.register({
  'lock-open': {
    width: 576,
    height: 512,
    paths: [{
      d: 'M423.5 0c84-0.3 152.5 68 152.5 152v80c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24v-80c0-39.9-32.7-72.4-72.7-72-39.6 0.4-71.3 33.3-71.3 72.9v71.1h48c26.5 0 48 21.5 48 48v192c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-192c0-26.5 21.5-48 48-48h224v-70.5c0-84 67.5-153.2 151.5-153.5z'
    }]
  }
});